module.exports = __webpack_public_path__ + "static/media/images.8be6c25a.png";